import * as React from 'react'
import './GlossaryItem.css';
import { GlossaryItem } from './GlossaryService';
import * as ReactDOM from 'react-dom';
import GlossaryItemLinksComponent from './GlossaryItemLinks';

export interface Props {
    term: GlossaryItem;
}

export interface State {
    isCollapsed: boolean;
}

export class GlossaryItemComponent extends React.Component<Props, State> {

    nativeElement: any;

    constructor(props: Props){
        super(props);

        this.state = {
            isCollapsed: true,
        }

        window.addEventListener('resize', event => {
            this.setCollapsed(this.state.isCollapsed);
        });

        window.addEventListener("hashchange", event => {
            const hashId = parseInt(event.newURL.split("#")[1]);

            const shouldFocus = hashId == this.props.term.id 

            this.focusOnElement(shouldFocus);
        }, false);
    }

    componentDidMount() {
        this.nativeElement = ReactDOM.findDOMNode(this);

        const shouldExpand = location.hash === ("#" + this.props.term.id.toString());

        this.setCollapsed(!shouldExpand);
    }

    render() {
        const { term } = this.props;

        return (
            <div className="glossary-term-card">
                <div className="glossary-term-card-heading" onClick={() => this.toggleCardItem()} >
                    <div className="glossary-term-card-collapse-button">
                        <img src={this.getCollapsedImage()}></img>
                    </div>
                    <div className="flex-grow">
                        <h4>{term.word}</h4>
                    </div>
                </div>

                <div className="glossary-term-card-description-container">
                    {this.props.term.description}
                </div>

                <GlossaryItemLinksComponent label="Vezani pojmovi" links={term.relatedLinks} />
                <GlossaryItemLinksComponent label="Vezane priče" links={term.relatedStories} />

            </div>
        )
    }

    toggleCardItem() {
        if(this.state.isCollapsed) {
            window.location.hash = this.props.term.id.toString();
            this.setCollapsed(false);
        } else {
            this.setCollapsed(true);
        }
    }

    focusOnElement(shouldFocus: boolean) {
        if(shouldFocus) {
            this.nativeElement.scrollIntoView();
        }

        this.setCollapsed(!shouldFocus);
    }

    private setCollapsed(isCollapsed: boolean) {
        this.setState(prevState => {
            return { isCollapsed }
        });

        if(isCollapsed) {
            this.nativeElement.style.transition = "none";
            this.nativeElement.style.height = "53px";
        } else {
            const height = this.nativeElement.scrollHeight
            this.nativeElement.style.transition = "height 200ms";
            this.nativeElement.style.height = height + "px";
        }
    }

    getCollapsedImage(): string {
        if(this.state.isCollapsed)
            return process.env.PUBLIC_URL + "/images/icon-right-black.png";
        else 
            return process.env.PUBLIC_URL + "/images/icon-down-black.png";
    }
}

export default GlossaryItemComponent;


// WEBPACK FOOTER //
// ./src/glossary/GlossaryItem.tsx